import { render, staticRenderFns } from "./LicitacaoFornecedorTermosPersonalizados.vue?vue&type=template&id=d675f10a&scoped=true"
import script from "./LicitacaoFornecedorTermosPersonalizados.vue?vue&type=script&lang=js"
export * from "./LicitacaoFornecedorTermosPersonalizados.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoFornecedorTermosPersonalizados.vue?vue&type=style&index=0&id=d675f10a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d675f10a",
  null
  
)

export default component.exports